import type { FC } from 'react';

import type { DesktopDisplayMode } from '../../types';
import { ProductGridSkeletonItem } from '../ProductGridSkeletonItem/ProductGridSkeletonItem';
import { getCardSize } from '../ProductGrid/getCardSize';
import { getResponsiveGridColumns } from '../ProductGrid/getResponsiveGridColumns';

export type ProductGridSkeletonProps = {
  /**
   * product card layout. Used to determine number of columns.
   *
   * @default 'cards'
   */
  displayMode: DesktopDisplayMode;
  /**
   * number of skeletons to display
   *
   * @default 72
   */
  count?: number;
};

/**
 * Display skeleton when products are loading instead of product cards
 */
export const ProductGridSkeleton: FC<ProductGridSkeletonProps> = ({
  displayMode = 'cards',
  count = 72,
}) => {
  const gridCols = getResponsiveGridColumns(displayMode);
  return (
    <ul className={`grid list-none gap-2 pl-0 md:gap-3 ${gridCols}`}>
      {[...new Array(count)].map((_, index) => (
        <li
          // eslint-disable-next-line react/no-array-index-key
          key={`skeleton_${index}`}
          className={getCardSize(displayMode)}
        >
          <ProductGridSkeletonItem />
        </li>
      ))}
    </ul>
  );
};
